<template>
    <div id="info-level-widget-component">
        <v-card class="elevation-0">
            <v-card-title>
                <HeaderWidgetComponent :is_open="is_open" :title="$t('level_component.title')" widget_name="info-level-component" />
            </v-card-title>

            <v-expand-transition>
                <div v-show="is_open">
                    <v-card-text class="pt-2 pb-4 text-center">
                        <v-row class="pb-4">
                            <v-col class="pb-0 pt-0">
                                <span class="font-12 font-color-light">{{ $t('level_component.volume_liter') }}</span>
                                <p class="asset-information">{{ numberWithSpaces(Math.round(asset.actual_volume)) }}L</p>
                            </v-col>
                            <v-divider color="white" vertical />
                            <v-col class="pb-0 pt-0">
                                <span class="font-12 font-color-light">{{ $t('level_component.hollow_liter') }}</span>
                                <p class="asset-information">{{ numberWithSpaces(Math.round(asset.hollow)) }}L</p>
                            </v-col>
                            <v-divider color="white" vertical />
                            <v-col class="pb-0 pt-0">
                                <span class="font-12 font-color-light">
                                    {{ $t('level_component.level_percentage') }}
                                </span>
                                <p class="asset-information">{{ Math.round(asset.remaining_level) }}%</p>
                            </v-col>
                        </v-row>
                    </v-card-text>
                </div>
            </v-expand-transition>
        </v-card>
    </div>
</template>

<script>
import HeaderWidgetComponent from './HeaderWidgetComponent.vue'

export default {
    name: 'InfoLevelWidgetComponent',
    components: { HeaderWidgetComponent },
    props: {
        is_open: {
            type: Boolean,
            required: false,
            default: false,
        },
        asset: {
            type: Object,
            required: true,
            default: function () {
                return { actual_volume: null, hollow: null, remaining_level: null }
            },
        },
    },
}
</script>
